export default __webpack_public_path__ + "static/delegator-e096a096a039923e013db5f9c3aacbb0.png";